import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../../api";
import Logo from "../../../images/logo-2.png";
import add from "../../../images/add.png";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";
import { Loader } from "../loader";
import { Modal } from "react-bootstrap";
import { useAlert } from "react-alert";

const allPermissions = [
  "crypto",
  "market",
  "stock",
  "education",
  "subscryption-data",
  "trade-summary",
  "live-session",
  "mobile-banner",
  "push-notification",
  "godzilla",
  "user-consent",
  "subscription-consent",
  "trade-monitor",
  "users",
  "paid-users",
];

export function UpdatePermissionModal({
  show,
  selectedData,
  handleClose,
  getData,
}) {
  const adminStore = useSelector((state) => state.adminReducer);
  const alert = useAlert();

  const [loader, setLoader] = useState(false);
  const [inputData, setInputData] = useState({
    video: "",
    category: "",
  });
  const [isRecording, setIsRecording] = useState(false);
  const [permissions, setPermissions] = useState([]);

  const handleSubmit = async () => {
    try {
      setLoader(true);
      const formData = {
        adminId: selectedData?._id,
        permissions: permissions,
      };

      const signalResponse = await api.adminAddPermission(formData);
      console.log(signalResponse);

      if (signalResponse?.success) {
        alert.success("Permission updated");
        getData();
        setLoader(false);
        handleClose();
      } else {
        setLoader(false);
        alert.error("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert.error("Something went wrong");
    }
  };

  const handleCheckboxChange = (perm) => {
    setPermissions((prev) =>
      prev.includes(perm) ? prev.filter((p) => p !== perm) : [...prev, perm],
    );
  };

  useEffect(() => {
    setInputData({ ...selectedData });
    setPermissions(selectedData?.permissions || []);
  }, [selectedData]);
  // console.log(permissions);

  return (
    <>
      <Modal show={show} size="lg" onHide={handleClose} centered className="">
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleClose}>
              <i className="fa-solid fa-xmark" />
            </div>
            <div className="row mx-0 drivers-row">
              <div className="col-xl-6 col-md-7  d-flex justify-content-between pr-0">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Manage Permissions
                </h4>
              </div>
            </div>
            <div className="card sortby-box br-10 border-transparent mt-3">
              <div className="card-header br-10  bg-white border-transparent py-3 ">
                <div className="descMainPost">
                  <div className="form-group mb-3">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={inputData?.name}
                      placeholder="Name"
                      disabled
                    />
                  </div>
                  <div className="form-group mb-3">
                    {allPermissions.map((perm) => (
                      <label key={perm} className="d-block mb-2 text-uppercase">
                        <input
                          type="checkbox"
                          checked={permissions.includes(perm)}
                          onChange={() => handleCheckboxChange(perm)}
                          className="me-2"
                        />
                        {perm}
                      </label>
                    ))}
                  </div>
                </div>

                <div className="sendMailBtn mt-3">
                  <button
                    onClick={handleSubmit}
                    className="btn-dark"
                    disabled={isRecording}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {loader && <Loader />}
    </>
  );
}
